import React, { FC } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import block from 'bem-cn'

import { ReactComponent as InfoIcon } from 'shared/img/AAABBB/promotions/info.svg'

import { IUserPromotion } from 'shared/models/Promotion'

import { selectLocaleDict } from 'features/locale/selectors'

import './Card.scss'

interface ICardHeaderProps {
  promotion: IUserPromotion
  logoIcon: string
  onInfoClick: () => void
}

const b = block('bonus-card-header')

export const CardHeader: FC<ICardHeaderProps> = ({ logoIcon, onInfoClick, promotion }) => {
  const locale = useSelector(selectLocaleDict, shallowEqual).bonuses

  const renderHeaderText = () => {
    if (promotion.name === 'register') {
      return <p className={b('gradient')}>{locale.registerBonus}</p>
    }

    if (promotion.name.includes('free') || promotion.freeSpinsCount > 0) {
      return (
        <>
          {' '}
          <p>{locale.giro}</p>
          <div />
          <p className={b('gradient')}>{locale.gratis}</p>
        </>
      )
    }

    return <p className={b('gradient')}>{locale.FirstDeposit}</p>
  }

  return (
    <div className={b()}>
      <div className={b('logo-text')}>{renderHeaderText()}</div>
      {/* <img src={logoIcon} alt="logo" className={b('img')} /> */}
      <InfoIcon className={b('info-icon')} onClick={onInfoClick} />
    </div>
  )
}
